import { dataWrapper } from 'core/data'

const { get } = dataWrapper

export const _getFNAConfiguration = (get) => get('fna-configuration')
export const getFNAConfiguration = () => _getFNAConfiguration(get)
